import React, { FC, useState } from 'react';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { Table } from '../../table/Table';
import { TablesNames } from '../../../store/tables/tables-context';
import { MRT_RowSelectionState } from 'material-react-table';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';
import { setMerchantFundReserveConfig } from '../../../store/merchnts/actions/fundsReserveConfig';
import { useParams } from 'react-router-dom';
import { fetchMerchantData } from '../../../store/merchnts/actions/merchant';

interface IProps {
  onClose: () => void;
}
export const MerchantsFundReserveModalContent: FC<IProps> = (props) => {
  const { onClose } = props;
  const { id: mid } = useParams<{ id: string }>();
  const { merchantState: { fundsReserveConfigActiveListData, isMerchantFundsReserveConfigLoading }, dispatch } = useMerchants();
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const handleApply = async (): Promise<void> => {
    const selectedItemId = Object.keys(rowSelection || {})?.[0];
    await setMerchantFundReserveConfig(dispatch, mid, selectedItemId);
    onClose();
    await fetchMerchantData(dispatch, mid);
  };

  return (
    <div className="px-8">
      <Table
        name={TablesNames.fundsReserveConfigActive}
        data={fundsReserveConfigActiveListData || []}
        isLoading={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableHiding={false}
        enableSelectAll={false}
        enableRowSelection={true}
        enableMultiRowSelection={false}
        enableRowClicking={true}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
      />
      <div className="text-center my-5">
        <ButtonComponent
          buttonName="Cancel"
          buttonType={BUTTON_TYPE.CANCELLED}
          additionalClass="btn-sm"
          onButtonClick={onClose}
        />
        <ButtonComponent
          buttonName="Apply"
          additionalClass="btn-sm ms-10 w-100px"
          loading={isMerchantFundsReserveConfigLoading}
          isDisabled={isMerchantFundsReserveConfigLoading}
          onButtonClick={handleApply}
        />
      </div>
    </div>
  );
};
